module.exports = __webpack_public_path__ + "static/img/news_10.388bcb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_10.jpg
// module id = myRx
// module chunks = 2